module.exports = __webpack_public_path__ + "static/media/handCharcoal.6d366246.jpg";